import { render, staticRenderFns } from "./NaoxjStockStatisticsSalesman.vue?vue&type=template&id=0999f541&scoped=true&"
import script from "./NaoxjStockStatisticsSalesman.vue?vue&type=script&lang=js&"
export * from "./NaoxjStockStatisticsSalesman.vue?vue&type=script&lang=js&"
import style0 from "./NaoxjStockStatisticsSalesman.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NaoxjStockStatisticsSalesman.vue?vue&type=style&index=1&id=0999f541&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0999f541",
  null
  
)

export default component.exports